import { Link } from "react-router-dom";
import { Home, BookOpen, GraduationCap, Heart, Youtube, Mail } from "lucide-react";

const BUTTONS = [
  { to: "/", label: "Return Home", Icon: Home },
  { to: "/devotionals", label: "Read Devotionals", Icon: BookOpen },
  { to: "/bible-studies", label: "Bible Studies", Icon: GraduationCap },
  { to: "/bible-promises", label: "Bible Promises", Icon: Heart },
  { to: "/videos", label: "Watch Videos", Icon: Youtube },
  { to: "/contact", label: "Contact Ministry", Icon: Mail },
];

export default function BottomNav({ exclude = [] }) {
  const items = BUTTONS.filter((b) => !exclude.includes(b.to));
  return (
    <section
      data-testid="bottom-nav"
      className="py-16 lg:py-20"
      style={{ backgroundColor: "var(--cream-100)" }}
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10">
          <div className="divider-cross">
            <span className="text-xs uppercase tracking-[0.32em] text-gold font-medium">
              Keep Walking with Jesus
            </span>
          </div>
          <h3 className="font-display text-2xl lg:text-3xl text-navy-deep mt-4">
            Where would you like to go next?
          </h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {items.map(({ to, label, Icon }) => (
            <Link
              key={to}
              to={to}
              data-testid={`bottom-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="lift bg-white border border-cream-200 rounded-xl p-5 flex items-center gap-3 hover:border-gold group"
            >
              <span
                className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors"
                style={{ backgroundColor: "var(--navy-800)", color: "var(--gold-400)" }}
              >
                <Icon size={18} />
              </span>
              <span className="text-navy font-medium text-sm lg:text-base">{label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
